import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";

const CheckAuthHome = observer(({ children }) => <div>{children}</div>);

export default CheckAuthHome;
